export const chunk = <T>(arr: Array<T>, len: number): Array<Array<T>> => {
    const chunks = [];
    let i = 0;
    const n = arr.length;

    while (i < n) {
        chunks.push(arr.slice(i, (i += len)));
    }

    return chunks;
};
